import {
    Container,
    Navbar,
    Nav,
    NavDropdown,
    Card,
    FormGroup,
    FormControl,
    Row,
    Col,
    FormLabel,
    Button
} from "react-bootstrap";
import TopMenu from "../components/topMenu";
import {createUseStyles} from "react-jss";
import {Link,useSearchParams } from "react-router-dom";
import {useEffect, useState} from "react";
import axios from "axios";
import Helper from "../helper";
import {useForm} from "react-hook-form";
import {NotificationManager} from "react-notifications";
const useStyles = createUseStyles({
    card_login:{
        '& div:nth-child(n+1)':{
            marginBottom:5
        }
    },
    bottom_link:{
        '& a':{
            textDecoration:'none',
        }
    }
});
const Login = ()=>{
    const classes = useStyles();
    const [searchParams, setSearchParams] = useSearchParams();
    const [clientID,setClientID] = useState(searchParams.get('client_id'));
    const [oauthState,setOauthState] = useState(searchParams.get('state'));
    const [disableLogin,setDisableLogin] = useState(false);

    const {register, handleSubmit, control, reset, getValues, formState: {errors}} = useForm({
        defaultValues: {
            username: '',
            password: '',
        }
    });

    useEffect(()=>{
        let query = document.location.href.split('?')[1];
        axios.get(Helper.URI('set-state')+`&${query}`).then(res=>{})
        sessionStorage.setItem('backLink',document.location.href);
    },[]);

    const onSubmit=data=>{
        axios.post(Helper.URI('login'),data).then(res=>{
            if(res.data.error){
                NotificationManager.error(res.data.error)
            }else{
                NotificationManager.success('Success, please wait...');
                setDisableLogin(true);
                setTimeout(()=>{
                    document.location.href=res.data.redirect;
                },1000);
            }
        })
    }

    return <>
        <TopMenu/>
        <Container className="mt-4">
            <Row className="justify-content-center">
                <Col xs={12} md={8} lg={5}>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Card className={classes.card_login}>
                            <Card.Header>
                                <h3>เข้าสู่ระบบ</h3>
                            </Card.Header>
                            <Card.Body>
                                <FormGroup>
                                    <FormLabel>เลขใบประกอบวิชาชีพ</FormLabel>
                                    <FormControl {...register('username')}/>
                                </FormGroup>
                                <FormGroup>
                                    <FormLabel>รหัสผ่าน</FormLabel>
                                    <FormControl type="password" {...register('password')}/>
                                </FormGroup>
                                <Row className='mt-2 justify-content-center'>
                                    <Col md={12}>
                                        <Button disabled={disableLogin} type='submit' style={{width:'100%'}}>เข้าสู่ระบบ{disableLogin?' (กำลังโหลด...)':''}</Button>
                                    </Col>
                                    <Col md={12}>
                                        <Button variant='light' type='button' style={{width:'100%'}} onClick={e=>{
                                            document.location.href='/';
                                        }}>กลับ</Button>
                                    </Col>
                                    <Col md={12} className={classes.bottom_link}>
                                        <div className='mt-2 text-end'>
                                            <Link to='/register'>ลงทะเบียนเข้าใช้งาน</Link>
                                        </div>
                                        <div className='mt-2 text-end'>
                                            <Link to='/forgot'>ลืมรหัสผ่าน</Link>
                                        </div>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </form>
                </Col>
            </Row>
        </Container>
    </>
}
export default Login;
